import { useConfigConditionValue } from 'features/config/useConfigConditionValue'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const allCodes = [
  'DE',
  'AT',
  'CH',
  'ES',
  'IT',
  'PL',
  'KW',
  'FI',
  'SE',
  'SK',
  'BE',
  'DK',
  'FR',
  'LI',
  'LU',
  'NL',
  'GB',
  'US',
  'CZ',
  'NO',
  'BG',
  'PT',
  'NZ',
  'CY',
  'HU',
]

export const useCountries = () => {
  // const region = useRegion()
  const { t } = useTranslation(['countries'])

  const codesConfig = useConfigConditionValue('country-codes', 'countries')

  const codes = useMemo(() => {
    if (codesConfig) {
      return codesConfig.codes
    }
    return allCodes
  }, [codesConfig])

  return useMemo(() => {
    return codes.map((code) => ({
      value: code,
      label: t(`countries:${code?.toLowerCase()}`),
    }))
  }, [codes, t])
}
